function animate(now, duration, fromX1, fromX2, toX1, toX2, fn, it) {
  const t = performance.now();
  const timeDiff = t - now;
  const timePercentage = Math.min(1, timeDiff / duration);
  const startDiff = toX1 - fromX1;
  const endDiff = toX2 - fromX2;
  const leftStep = startDiff * timePercentage;
  const rightStep = endDiff * timePercentage;

  fn(fromX1 + leftStep, fromX2 + rightStep);

  if (timeDiff > duration || it > 100) {
    return;
  }

  requestAnimationFrame(() => {
    animate(now, duration, fromX1, fromX2, toX1, toX2, fn, it + 1);
  }, 0);
}

function interpolateTransition(fn, duration, fromX1, fromX2, toX1, toX2) {
  const now = performance.now();
  const iterations = 0;
  animate(now, duration, fromX1, fromX2, toX1, toX2, fn, iterations);
}

export default interpolateTransition;
